import { defineComponent as _defineComponent } from 'vue'
import { useGetTagsQuery } from '@/api/tags'
import { computed, ref, withDefaults } from 'vue'
import { useQueryClient } from '@tanstack/vue-query'

interface Props {
  value: string[]
  hubId: string
  disabled?: boolean
  showCreateCustomTag?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketTags',
  props: {
    value: { default: () => [] },
    hubId: null,
    disabled: { type: Boolean, default: false },
    showCreateCustomTag: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'input', value: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string[], hubId: string, disabled: boolean, showCreateCustomTag: boolean }





const searchValue = ref('')
const autocomplete = ref<any>(null)

const { data: tagOptions } = useGetTagsQuery()
const queryClient = useQueryClient()

const options = computed(() => {
  if (!tagOptions.value) return []

  const tagsForHub = tagOptions.value
    .filter((tag) => tag.ownerId === props.hubId)
    .map((tag) => tag.name)
  const values = new Set([...tagsForHub, ...props.value])
  return [...values].map((tag) => ({ text: tag, value: tag }))
})

const matchingOption = computed(() => {
  const matched = options.value.find(
    (tag: any) => tag.text.toLowerCase() === searchValue.value.toLowerCase()
  )
  return matched ? matched.text : null
})

const isSearchAlreadyAdded = computed(() => {
  const lowerCaseValues = props.value.map((tag) => tag.toLowerCase())
  return lowerCaseValues.includes(searchValue.value.toLowerCase())
})

const showCustomTagOption = computed(() => {
  return (
    searchValue.value.length > 0 &&
    !matchingOption.value &&
    props.showCreateCustomTag
  )
})

function handleInput(newValue: string[]) {
  emit('input', newValue)
}

function resetField() {
  searchValue.value = ''
  if (autocomplete.value) {
    autocomplete.value.focus()
    if (typeof autocomplete.value.clearSearchValue === 'function') {
      autocomplete.value.clearSearchValue()
    }
  }
}

function handleAddMatchingOption() {
  if (matchingOption.value) {
    handleInput([...props.value, matchingOption.value])
    resetField()
  }
}

function handleCustomAdd() {
  handleInput([...props.value, searchValue.value])

  const newTag = { name: searchValue.value, ownerId: props.hubId }
  queryClient.setQueryData(['tags'], (oldData) => {
    return Array.isArray(oldData) ? [...oldData, newTag] : [newTag]
  })

  resetField()
}

function handleHotKeys(event: KeyboardEvent) {
  if (searchValue.value.length) {
    event.preventDefault()
    if (isSearchAlreadyAdded.value) {
      resetField()
    } else if (matchingOption.value) {
      handleAddMatchingOption()
    } else {
      handleCustomAdd()
    }
  }
}

expose({ options })

return { __sfc: true,props, emit, searchValue, autocomplete, tagOptions, queryClient, options, matchingOption, isSearchAlreadyAdded, showCustomTagOption, handleInput, resetField, handleAddMatchingOption, handleCustomAdd, handleHotKeys }
}

})